import { api } from "@/APIRequests";
import type { CareTeamMember } from "@/core/types";

export async function getCareTeam(
  patientId: string,
  queryParams: Record<string, string> = { show_history: "true" },
): Promise<CareTeamMember[]> {
  return api.sharedTyped.fetch_patient_careteam({
    params: { showLoader: false },
    patientId,
    queryParams,
  });
}
